import React, { useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { LoadingContainer } from '@src/screens/Common/containers/LoadingContainer'
import { UiFlags } from '@src/types'
import { OnboardingStackParamsList } from '@src/navigation/types'
import Storage, { VideoCallData, useStorageValue } from '@src/utils/storage'
import { useDispatchAsync } from '@src/utils'

export const InsuranceCheck = () => {
  const navigation = useNavigation<StackNavigationProp<OnboardingStackParamsList>>()
  const dispatchAsync = useDispatchAsync()

  const [videoCallData] = useStorageValue<VideoCallData>(Storage.VIDEO_CALL_DATA_KEY)

  const { meetingAt, coachId } = videoCallData || {}

  useEffect(() => {
    let cancelled = false

    const decideRoute = async () => {
      // Fetch a fresh `insuranceInformationSubmitted` flag - the cached
      // value can be stale (the flag is only set via the web pass-through
      // flow).
      const uiFlags: UiFlags = await dispatchAsync({ type: 'uiFlags/fetch' })
      if (cancelled) {
        return
      }

      if (uiFlags.insuranceInformationSubmitted) {
        navigation.replace('InsuranceAddress')
      } else {
        navigation.replace('PaidVideoCallsProductExplanation', { meetingAt, coachId })
      }
    }

    decideRoute()

    return () => {
      cancelled = true
    }
  }, [coachId, dispatchAsync, meetingAt, navigation])

  return <LoadingContainer loadingMessage="Checking insurance..." />
}
